import { __decorate, __metadata } from "tslib";
// NPM
import { Component, Prop, Mixins } from "vue-property-decorator";
import simplebar from "simplebar-vue";
import BaseMixer from "@/router/views/BaseMixer";
import { CycleModule } from "@/store/modules/cycle.module";
import { PACycleSaveModel } from "@/store/models/cycle/paCycleSaveDTO";
import DeleteComponent from "@/components/deleteComponent.vue";
let SelectWorkflowComponent = /** @class */ (() => {
    var _a;
    let SelectWorkflowComponent = class SelectWorkflowComponent extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.showDeleteModal = false;
            this.employeeId = null;
        }
        SelectWorkFlow(employeeId) {
            this.addWorkFlowToEmployee(employeeId);
        }
        addWorkFlowToEmployee(employeeId) {
            const employee = this.EmployeesWorFlow.find((x) => x.id == employeeId);
            const workFlowName = this.workFlows.find((x) => x.id == employee.workFlowId).code;
            if (employee) {
                const savedEmployee = this.EmployeesWorFlow.find((x) => x.id == employeeId);
                if (savedEmployee) {
                    savedEmployee.workFlowId = employee.workFlowId;
                    savedEmployee.workFlowName = workFlowName;
                }
            }
        }
        addDataToProp() {
            this.paCycleSave.reviews = this.EmployeesWorFlow.map((emp) => ({
                id: emp.id,
                workFlowId: emp.workFlowId,
                reportingTo: emp.reportingTo,
            }));
        }
        deleteReviewForEmployee() {
            this.EmployeesWorFlow = this.EmployeesWorFlow.filter((employee) => employee.id != this.employeeId);
            CycleModule.DeleteEmployeeFromCycleReview(this.employeeId);
            this.showDeleteModal = false;
        }
        openDeleteModal(id) {
            this.employeeId = id;
            this.showDeleteModal = true;
        }
        cancelDelete() {
            this.showDeleteModal = false;
        }
        get workFlows() {
            return CycleModule.workFlows;
        }
        destroyed() {
            this.addDataToProp();
        }
    };
    __decorate([
        Prop(),
        __metadata("design:type", Array)
    ], SelectWorkflowComponent.prototype, "EmployeesWorFlow", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", typeof (_a = typeof PACycleSaveModel !== "undefined" && PACycleSaveModel) === "function" ? _a : Object)
    ], SelectWorkflowComponent.prototype, "paCycleSave", void 0);
    SelectWorkflowComponent = __decorate([
        Component({
            name: "SelectWorkflowComponent",
            components: {
                simplebar,
                DeleteComponent,
            },
        })
    ], SelectWorkflowComponent);
    return SelectWorkflowComponent;
})();
export default SelectWorkflowComponent;
